<div>
    <div class="separator"></div>
    <div class="ui two column grid">
        <div class="column">
            <div class="ui left icon input" id="emailId">
                <input type="text" placeholder="Email" [(ngModel)]="email" (keyup)="onEmailChanged()">
                <i class="mail icon"></i>
            </div>
            <div class="ui left icon input" id="phone">
                <input type="text" placeholder="Téléphone" [(ngModel)]="phone" (keyup)="onPhoneChanged()">
                <i class="phone icon"></i>
            </div>
        </div>
        <div class="column">
            <div class="ui left icon input" id="firstname">
                <input type="text" placeholder="Prénom" [(ngModel)]="firstname" (keyup)="onFirstnameChanged()">
                <i class="user icon"></i>
            </div>
            <div class="ui left icon input" id="lastname">
                <input type="text" placeholder="Nom" [(ngModel)]="lastname" (keyup)="onLastnameChanged()">
                <i class="user icon"></i>
            </div>
        </div>
    </div>
    <div>
        <p class="margin-top-20 text-center desktop">Veuillez indiquer les heures auxquelles vous souhaitez obtenir et ramener le véhicule.</p>
        <textarea placeholder="Votre remarque"  [(ngModel)]="comment"></textarea>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/user/user.html